import { useState, useEffect } from 'react'
import { LATEST_CHANGELOG_VERSION } from '@/constants/changelog'

const STORAGE_KEY = 'immotron-last-seen-changelog'

export function useWhatsNew() {
  const [hasNew, setHasNew] = useState(false)

  useEffect(() => {
    const lastSeen = localStorage.getItem(STORAGE_KEY)
    if (lastSeen !== LATEST_CHANGELOG_VERSION) {
      setHasNew(true)
    }
  }, [])

  const markSeen = () => {
    localStorage.setItem(STORAGE_KEY, LATEST_CHANGELOG_VERSION)
    setHasNew(false)
  }

  return { hasNew, markSeen }
}
